import icons from './utils/icons'
import storage from '../../store/storage'

const { VUE_APP_VERSION } = process.env

const STORAGE_KEY_NAV_STATE = 'isNavCollapsed'
const STORAGE_KEY_NAV_WIDTH = 'navWidth'

const drawerState = storage.getDrawerState(STORAGE_KEY_NAV_STATE)
const drawerWidth = storage.getDrawerWidth(STORAGE_KEY_NAV_WIDTH) || 250

const isNavCollapsed = storage.isTrue(drawerState)

const state = () => ({
  currentRoute: {},

  darkMode: false,

  drawerDefaults: Object.freeze({
    min: 250,
    max: window.innerWidth - 64,
  }),
  drawerDragStartX: 0,
  drawerDragStartWidth: drawerWidth,
  drawerWidth,

  formContact: { action: 'update', entry: null },
  formCustomAnalytic: { action: 'create', entry: null },
  formNetwork: { action: 'create', entry: null },
  formQuery: { all: { action: 'create', entry: null } },
  formShare: { action: 'update', entry: null },

  icons,

  isModalVisibleContact: false,
  isModalVisibleCustomAnalytic: false,
  isModalVisibleNetwork: false,
  isModalVisibleQuery: false,
  isModalVisibleSettings: false,
  isModalVisibleShare: false,

  isLayoutFullScreen: false,

  isNavCollapsed,
  isResizingNavigation: false,

  promptError: false,
  promptRefresh: false,
  serviceWorkerRegistration: null,

  STORAGE_KEY_NAV_STATE,
  STORAGE_KEY_NAV_WIDTH,

  theme: 'light',

  version: VUE_APP_VERSION,
})

export default state
